/**
 * File booking.js.
 *
 * Functionality for booking rooms
 */

 var xhr;
 var previousWidth = window.innerWidth;

 ( function( $ ) {
 	var largeBreak = 1024;
	var $toggleButtons = $('.feature-row--booking .button--toggle');
	var $requestForms = $('.request-form');

	if ($toggleButtons.length === 0 || $requestForms.length === 0) {
		return;
	}

	var $menu = $('#main-menu');
	var $dateFields = $requestForms.find('input[name*="time"]');
	var $reveal = $('.reveal');
	var $submittedForm;

	// Intialize datepickers
	var nowTemp = new Date();
	var now = new Date(nowTemp.getFullYear(), nowTemp.getMonth(), nowTemp.getDate(), 0, 0, 0, 0);

	if ($dateFields.length > 0) {
		$dateFields.fdatepicker({
			leftArrow: '<',
			rightArrow: '>',
			format: 'mm/dd/yyyy - hh:ii',
			disableDblClickSelection: true,
			pickTime: true,
			startDate: now
		});
	}


	/**
	 * Listener for 'Rent This Room' buttons that hides the info and reveals the rental form
	 */
	$toggleButtons.on('click', function(event) {
		var $content = $(event.target).parent();
		var $container = $content.parent();
		var $requestForm = $container.find('.request-form');
		var $row = $container.parent();

		if (window.innerWidth >= largeBreak) {
			// Adjust row height if form is greater than current height
			if ($requestForm.outerHeight() >= $row.outerHeight()) {
				$row.css('height', $requestForm.outerHeight() * 1.1);
			}

			// Animate opacity of info to 0, and form to 1
			$content.animate({opacity: 0}, 200);
			$requestForm.animate({opacity: 1}, 300, function() {
				$requestForm.css('z-index', 3);
			});
		}
		else {
			// Form is full screen and fixed so add padding to account for menu height
			$requestForm.css('padding-top', $menu.outerHeight());

			// Fade in form and hide overflow on body
			$requestForm.fadeIn(300, function() {
				$('body').css('overflow', 'hidden');
			});
		}
	});

	/**
	 * Listener for 'Cancel' buttons in the booking form that resets andhides the form, then reveals the info
	 */
	$requestForms.find('a.cancel').on('click', function(event) {
		$(event.target).parents('.request-form')[0].reset();
		hideForm($(event.target).parents('.feature-row'));
	});

	$requestForms.on('submit', function(event) {
		event.preventDefault();

		// Abort if a previous request is active
		if (xhr){
			return;
		}

		var action;
		var formData = $(event.target).serialize();
		var $button = $(event.target).find('.button');
		var buttonContent = $button.html();
		$submittedForm = $(event.target); // most recently submitted form used in reveal on close handler

		if ($submittedForm.hasClass('request-form--booking')) {
			action = 'booking_request';
		}
		else if ($submittedForm.hasClass('request-form--registration')) {
			action = 'program_registration';
		}

		// Add spinner to button and fade out any visible form errors
		$button.html('<span class="spinner2"></span>');
		$submittedForm.find('.form-error').fadeOut(300);

		// Submit form data
		xhr = $.ajax({
			url: ajaxURL,
			type: 'POST',
			dataType: 'JSON',
			data: 'action='+action+'&'+formData,
			success: function(result) {
				var showReveal = true;

				// Set default heading and reset button text
				var heading = 'Oops, something went wrong';
				$button.html(buttonContent);

				if (result.status !== 'error') {
					// Update the heading text if there is no error
					heading = result.status.charAt(0).toUpperCase() + result.status.slice(1);
				}
				else if (result.valErrors && Object.keys(result.valErrors).length > 0) {
					// Update an error text and fade in the error text
					var keys = Object.keys(result.valErrors);

					for (var i = 0; i < keys.length; i++) {
						$submittedForm.find('input[name="' + keys[i] + '"], textarea[name="' + keys[i] + '"], select[name="' + keys[i] + '"]').next('.form-error').text(result.valErrors[keys[i]]).fadeIn(300);
					}

					showReveal = false;
				}

				if (showReveal) {
					// Set reveal window values and display it
					$reveal.find('h4').removeClass().addClass(result.status).text(heading);
					$reveal.find('p').text(result.message);
					$reveal.foundation('open');
				}

				xhr = null;
			},
			error: function() {
				$button.html(buttonContent);

				// Set reveal window values and display it
				$reveal.find('h4').removeClass().addClass('error').text('Oops, something went wrong');
				$reveal.find('p').text('An unknown error occurred.');
				$reveal.foundation('open');

				xhr = null;
			}
		});
	});


	/**
	 * Listener for window resize that resets the form and info when switching between small/medium and large screens
	 */
	$(window).on('resize', function() {
		if (window.innerWidth >= largeBreak && previousWidth < largeBreak) {
			if ($dateFields.length > 0) {
				$dateFields.fdatepicker('hide');
			}

			$('body').css('overflow', 'auto');

			$requestForms.css({
				'opacity': 0,
				'padding-top': 0,
				'display': 'block',
				'z-index': 1
			});
		}
		else if (window.innerWidth < largeBreak && previousWidth >= largeBreak) {
			if ($dateFields.length > 0) {
				$dateFields.fdatepicker('hide');
			}

			$('.feature-row--booking').removeAttr('style');
			$('.feature-row__text').css('opacity', 1);

			$requestForms.css({
				'opacity': 1,
				'padding-top': $menu.outerHeight(),
				'display': 'none',
				'z-index': 3
			});
		}

		previousWidth = window.innerWidth;
	});

	/**
	 * Listener for Foundation reveal element's on close event that hides and resets the form if the submission was successful
	 */
	$(document).on('closed.zf.reveal', function(event) {
		if ($submittedForm && $reveal.find('h4').hasClass('success')) {
			hideForm($submittedForm.parents('.feature-row'));
			$submittedForm[0].reset();
			$submittedForm = null;
		}
	});

	/**
	 * Function that hides for form and reveals the info
	 *
	 * @param {jQuery object}		The row containing the form and info
	 */
	function hideForm($row) {
		var $requestForm = $row.find('.request-form');
		var $content = $row.find('.feature-row__text');

		if (window.innerWidth >= largeBreak) {
			// Remove any styles (i.e. height) that were added to the row
			if ($row.attr('style')) {
				$row.removeAttr('style');
			}

			// Reset form z-index and animate opacity of form to 0 and info to 1
			$requestForm.css('z-index', 1);
			$requestForm.animate({opacity: 0}, 200);
			$content.animate({opacity: 1}, 300);
		}
		else {
			// Fade out form and reset the body's overflow
			$requestForm.fadeOut(300, function() {
				$('body').css('overflow', 'auto');
			});
		}
	}

} )( jQuery );